import Linkable from "component/LinkableComponent/linkable-component";
import { API_BASE_URL } from "configs/AppConfig";
import React from "react";
import { Col, Row } from "react-bootstrap";

const InfographicSearchCard = ({ infographics }) => {
  const RenderInfograpgics = () => {
    const list = infographics
      .slice(0, 3)
      .map(({ infographicUrl, publicationDetailId }, index) => (
        <Col xs={12} md={6} lg={4} xl={4} xxl={3} key={index}>
          <Linkable link={`infograph/${publicationDetailId}`}>
            <img
              src={`${API_BASE_URL}/${infographicUrl}`}
              alt="infographics-img"
              loading="lazy"
            />
          </Linkable>
        </Col>
      ));
    return list;
  };
  return (
    <div className="infographics">
      <Row>
        <RenderInfograpgics />
      </Row>
    </div>
  );
};

export default InfographicSearchCard;
